import { GridFilterModel, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultSortModel: GridSortModel = [{ field: 'createdAt', sort: 'desc' }]
export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
